import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, TextField, FormHelperText, CircularProgress, FormControlLabel, FormGroup, Switch, Autocomplete } from "@mui/material";
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';
import { LinearProgress } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef, useMemo } from "react";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';

import { UsuarioService } from "../../shared/services/api/usuario/UsuarioService";
import { AlertSnackBar, AutoCompleteDeCliente, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";

import { VTextField, VForm, useVForm } from "../../shared/forms";
import { VSwitch } from "../../shared/forms/VSwitch";

import { List, Card, CardHeader, ListItem, ListItemText, ListItemIcon, Checkbox, Button, Divider, Typography } from '@mui/material';

import { IPerfil } from "../../shared/services/api/perfil/PerfilService";
import { Usuario_Perfil_Service, IUsuario_Perfil } from "../../shared/services/api/usuario_perfil/Usuario_Perfil_Service";
import { Environment } from "../../shared/environment";

import jwt_decode from "jwt-decode";
import { TJwtToken } from "../../shared/services/api/usuario/auth/AuthService";
import { ClienteService, ICliente } from "../../shared/services/api/cliente/ClienteService";
import { IUsuario_Cliente, Usuario_Cliente_Service } from "../../shared/services/api/usuario_cliente/Usuario_Cliente_Service";
import { DatePicker } from "@mui/x-date-pickers";

import dayjs from 'dayjs';
import { useAppThemeContext } from "../../shared/contexts";
import { CampoTextoMascarado } from "../../shared/components/campo-texto-mascarado/CampoTextoMascarado";

interface IFormData {
    cpf: string;
    nome: string;
    email: string;
    celular: string;
    uf: string;
    master: boolean;
    gestor: boolean;
    funcionarioZ: boolean,
    expiracaoSenha: string | null,
}
interface IFormValidation {
    cpf: string;
    nome: string;
    email: string;
    celular: string;
    uf: string;
}

interface ListaPerfil {
    idPerfil: number;
    nomePerfil: string;
    cnpj: string;
}

interface ListaCliente {
    cnpj: string;
    nome: string;
}

const formValidationSchema: yup.SchemaOf<IFormValidation> = yup.object().shape({
    cpf: yup.string().required().min(11),
    nome: yup.string().required('Nome é obrigatório'),
    email: yup.string().required('Email é obrigatório').email('Digite um email válido'),
    celular: yup.string().required().min(11),
    uf: yup.string().required(),
    expiracaoSenha: yup.string().notRequired(),
});

export const DetalheDeUsuario: React.FC = () => {
    const { idUsuario = 'novo' } = useParams<'idUsuario'>();
    const navigate = useNavigate();

    const { themeName } = useAppThemeContext();

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const token = localStorage.getItem("ACESS_TOKEN");
    //@ts-expect-error
    const decoded: TJwtToken = jwt_decode(token);

    const [visao, setVisao] = useState(decoded.role);

    useEffect(() => {// toda vez que o token for mudado
        const token = localStorage.getItem("ACESS_TOKEN");
        //@ts-expect-error
        const decoded: TJwtToken = jwt_decode(token);
        setVisao(decoded.role);

        if (decoded.role === "gestor") {

        }
    }, [localStorage.getItem("ACESS_TOKEN")]);

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCpf] = useState('');
    const [celular, setCelular] = useState('');

    const [master, setMaster] = useState(false);
    const [gestor, setGestor] = useState(false);
    const [funcionarioCliente, setFuncionarioCliente] = useState(false);

    const [errorCpf, setErrorCpf] = useState(false);
    const [errorCelular, setErrorCelular] = useState(false);

    const [maskedCpf, setMaskedCpf] = useState('');
    const [maskedCelular, setMaskedCelular] = useState('');

    const [uf, setUf] = useState('');
    const [errorUf, setErrorUf] = useState(false);

    const handleChangeUf = (event: SelectChangeEvent) => {
        setUf(event.target.value as string);
        setErrorUf(false);
    };

    const limparCampos = () => {
        formRef.current?.setData({
            nome: '',
            email: ''
        });
        setMaskedCpf("");
        setMaskedCelular('');
        setUf('');

        setMaster(false);
        setGestor(false);
        setFuncionarioCliente(false);

        setClientesDisponiveis([]);// retira os disponiveis
        clientes.map(cliente => setClientesDisponiveis((prevClientes) => [...prevClientes, { cnpj: cliente.cnpj, nome: cliente.nome }]));// coloca de novo
        setClientesSelecionados([]);// retira os selecionados

        setPerfisDisponiveis([]);// retira os disponiveis
        perfis.map(perfil => setPerfisDisponiveis((prevPerfis) => [...prevPerfis, { idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }]));// coloca de novo
        setPerfisSelecionados([]);// retira os selecionados

    };

    const handleChangeCpf = (valorMascarado: string) => {
        setMaskedCpf(valorMascarado);
        setErrorCpf(false);
    };
    const handleChangeCelular = (valorMascarado: string) => {
        setMaskedCelular(valorMascarado);
        setErrorCelular(false);
    };

    useEffect(() => {

        if (idUsuario !== 'novo') {
            setIsLoading(true);
            setNome("Carregando...");

            setIsLoadingListaCliente(true);
            setIsLoadingListaPerfil(true);

            UsuarioService.getById(Number(idUsuario)).then((result) => {

                setIsLoading(false);

                if (result instanceof Error) {

                    setIsLoadingListaCliente(false);
                    setIsLoadingListaPerfil(false);

                    // se der erro, volta para a listagem para não ficar uma tela em branco
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);

                    navigate('/usuario');

                } else {

                    setNome(result.nome);

                    if (!result.master && !result.funcionarioZ && !result.gestor) setFuncionarioCliente(true);
                    if (!!result.gestor) setGestor(result.gestor);
                    if (!!result.master) setMaster(result.master);

                    //pegar os dados que não podem ser iguais para não serem enviados na request
                    setEmail(result.email);
                    setCpf(result.cpf);
                    setCelular(result.celular);// saber se o telefone foi alterado para retirar a mascara

                    if (result.senha === null || result.senha === "") setVincularAD(true);
                    //setar os dados nos campos
                    formRef.current?.setData(result);
                    setUf(result.uf);

                    setMaskedCpf(result.cpf);
                    setMaskedCelular(result.celular);

                    if (!!result.validadeSenha) {
                        setValidadeSenhaFlag(true);
                        setValidadeSenha(result.validadeSenha);
                    }

                    if (!result.master && !result.gestor && visao === "master") {

                        if (dataFetchedClientes_UsuarioRef.current) return;// se ja tiver pego os dados volta(previnir que renderize mais de uma vez)
                        dataFetchedClientes_UsuarioRef.current = true;

                        Usuario_Cliente_Service.getByIdUsuario(Number(idUsuario)).then((resultCliente_usuario) => {

                            if (resultCliente_usuario instanceof Error) {//verificar se deu erro

                                setIsLoadingListaCliente(false);
                                setIsLoadingListaPerfil(false);

                                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultCliente_usuario.message });
                                setTimeout(() => {
                                    setAlertSnackbar(undefined);
                                }, duracaoAlert);

                            }

                            else {

                                //Funcionário cliente
                                if (result.gestor === false && result.funcionarioZ == false && result.master === false) {

                                    setCnpj(resultCliente_usuario[0].cnpj);
                                    carregaPerfis([resultCliente_usuario[0].cnpj]);

                                } else {

                                    ClienteService.list().then((resultCliente) => {

                                        if (resultCliente instanceof Error) {//verificar se deu erro

                                            setAlertSnackbar({ tipoAlert: "erro", mensagem: resultCliente.message });
                                            setTimeout(() => {
                                                setAlertSnackbar(undefined);
                                            }, duracaoAlert);

                                        } else {

                                            setClientes(resultCliente);

                                            let auxDisponivel: ListaCliente[] = [];
                                            let auxSelecionados: ListaCliente[] = [];


                                            resultCliente.map(cliente => auxDisponivel.push({ cnpj: cliente.cnpj, nome: cliente.nome }));// coloca todos os clientes na lista de disponiveis

                                            resultCliente_usuario.map(cliente => auxSelecionados.push({ cnpj: cliente.cnpj, nome: cliente.nome }));// coloca os clientes do usuario na lista de selecionados
                                            auxDisponivel = auxDisponivel.filter(val => !auxSelecionados.includes(val));//remove os disponiveis


                                            setClientesDisponiveis(auxDisponivel);
                                            setClientesSelecionados(auxSelecionados);

                                            setIsLoadingListaCliente(false);

                                            if (!result.gestor && !result.master) {

                                                carregaPerfis(resultCliente_usuario.map(item => { return item.cnpj }));

                                            }

                                        }
                                    });

                                }

                            }
                        });

                    } else if (!result.master && !result.gestor && visao === "clienteGestor") {

                        Usuario_Cliente_Service.getByIdUsuario(Number(idUsuario)).then((resultCliente_usuario) => {

                            if (resultCliente_usuario instanceof Error) {//verificar se deu erro

                                setIsLoadingListaCliente(false);
                                setIsLoadingListaPerfil(false);

                                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultCliente_usuario.message });
                                setTimeout(() => {
                                    setAlertSnackbar(undefined);
                                }, duracaoAlert);

                            }

                            else {

                                setCnpj(resultCliente_usuario[0].cnpj);
                                carregaPerfis([resultCliente_usuario[0].cnpj]);

                            }
                        });

                    }

                }
            });
        } else {// quando clicar no botão novo resetar os campos

            formRef.current?.setData({
                nome: '',
                email: ''
            });
            setUf('');
            setMaskedCpf('');
            setMaskedCelular('');

            setCnpjPerfil("");

            setClientesDisponiveis([]);// retira os disponiveis
            clientes.map(cliente => setClientesDisponiveis((prevClientes) => [...prevClientes, { cnpj: cliente.cnpj, nome: cliente.nome }]));// coloca de novo
            setClientesSelecionados([]);// retira os selecionados

            setPerfisDisponiveis([]);// retira os disponiveis
            perfis.map(perfil => setPerfisDisponiveis((prevPerfis) => [...prevPerfis, { idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }]));// coloca de novo
            setPerfisSelecionados([]);// retira os selecionados

        }

        if (idUsuario === "novo" && visao === "master") {

            setIsLoadingListaCliente(true);

            ClienteService.list().then((result) => {

                setIsLoadingListaCliente(false);

                if (result instanceof Error) {//verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {

                    setClientes(result);

                    let auxCliente: ListaCliente[] = []
                    result.map(cliente => auxCliente.push({ cnpj: cliente.cnpj, nome: cliente.nome }));
                    setClientesDisponiveis(auxCliente);

                }
            });
        }

        if (idUsuario === "novo" && visao === "clienteGestor") {
            setCnpj(localStorage.getItem("cnpj"));
        }


    }, [idUsuario]);

    function carregaPerfis(cpfs: string[]) {
        setIsLoadingListaPerfil(true);

        Usuario_Perfil_Service.getAllByCnpjs(cpfs).then((resultPerfis) => {


            if (resultPerfis instanceof Error) {//verificar se deu erro

                setIsLoadingListaPerfil(false);

                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultPerfis.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

            } else {

                setPerfis(resultPerfis);

                Usuario_Perfil_Service.getByIdUsuario(Number(idUsuario)).then((resultPerfil_Usuario) => {

                    setIsLoadingListaPerfil(false);

                    if (resultPerfil_Usuario instanceof Error) {//verificar se deu erro

                        let auxDisponivel: ListaPerfil[] = [];
                        resultPerfis.map(perfil => auxDisponivel.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }));// coloca todos os clientes na lista de disponiveis
                        setPerfisDisponiveis(auxDisponivel);

                        setIsLoadingListaPerfil(false);
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: resultPerfil_Usuario.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                    } else {

                        let auxPerfil_Usuario: IPerfil[] = [];
                        resultPerfis.map(perfil => {
                            resultPerfil_Usuario.map(perfil_usuario => {

                                if (perfil_usuario.idPerfil === perfil.idPerfil) auxPerfil_Usuario.push(perfil);

                            });
                        })

                        let auxDisponivel: ListaPerfil[] = [];
                        let auxSelecionados: ListaPerfil[] = [];

                        resultPerfis.map(perfil => auxDisponivel.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }));// coloca todos os clientes na lista de disponiveis

                        auxPerfil_Usuario.map(perfil => auxSelecionados.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }));// coloca os clientes do usuario na lista de selecionados
                        auxDisponivel = auxDisponivel.filter((obj1) => !auxSelecionados.some((obj2) => obj1.idPerfil === obj2.idPerfil));

                        setPerfisDisponiveis(auxDisponivel);
                        setPerfisSelecionados(auxSelecionados);

                        setIsLoadingListaPerfil(false);

                    }

                });

            }
        });
    }

    useEffect(() => {
        if (!gestor && !master && !funcionarioCliente && idUsuario !== "novo") {
            ClienteService.list().then((result) => {

                setIsLoadingListaCliente(false);

                if (result instanceof Error) {//verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {

                    setClientes(result);

                    let auxCliente: ListaCliente[] = []
                    result.map(cliente => auxCliente.push({ cnpj: cliente.cnpj, nome: cliente.nome }));
                    setClientesDisponiveis(auxCliente);

                }
            });
        }
    }, [gestor, master, funcionarioCliente]);

    function selecaoCliente() {

        //Se for funcionário ZDOC
        if ((!master && !gestor && !funcionarioCliente) && visao === "master") {

            return (
                <>
                    <Box display="block">
                        {!master && <Typography sx={{ m: 2 }} align={"center"} variant="h5"> Selecionar Cliente </Typography>}

                        <Grid container spacing={2} justifyContent="center" alignItems="center">

                            <Grid item>{customListClientes('Clientes disponíveis', clientesDisponiveis)}</Grid>
                            <Grid item>
                                <Grid container direction="column" alignItems="center">
                                    <Button
                                        sx={{
                                            my: 0.5,
                                            color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                            '&.Mui-disabled': {
                                                color: 'theme.palette.action.disabled',
                                            },
                                            borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                        }}
                                        variant="outlined"
                                        size="small"
                                        onClick={handleClientesCheckedRight}
                                        disabled={clientesDisponiveisChecked.length === 0}
                                    >
                                        &gt;
                                    </Button>
                                    <Button
                                        sx={{
                                            my: 0.5,
                                            color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                            '&.Mui-disabled': {
                                                color: 'theme.palette.action.disabled',
                                            },
                                            borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                        }}
                                        variant="outlined"
                                        size="small"
                                        onClick={handleClientesCheckedLeft}
                                        disabled={clientesSelecionadosChecked.length === 0}
                                    >
                                        &lt;
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item>{customListClientes('Clientes selecionados', clientesSelecionados)}</Grid>
                        </Grid>
                    </Box>
                </>
            );

        } else if (!master) {

            return (
                <Box>
                    {visao === "master" && <Typography sx={{ m: 2 }} align={"center"} variant="h5"> Selecionar Cliente </Typography>}

                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid item xs={12} sm={12} md={6}>
                            <AutoCompleteDeCliente paraCadastro width={300} selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />
                        </Grid>

                    </Grid>
                </Box>
            );

        }
    }

    const [cnpjPerfil, setCnpjPerfil] = useState("");

    function selecaoPerfil() {

        if (!gestor && !master) {

            var opcoes: { id: string, label: string }[] = [];
            clientesSelecionados.map(cliente => opcoes.push({ id: cliente.cnpj, label: cliente.nome }));

            return (<Box display="block">
                {!master && <Typography sx={{ m: 2 }} align={"center"} variant="h5"> Selecionar Perfil </Typography>}


                {clientesSelecionados.length > 1 && !funcionarioCliente && (
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Autocomplete
                            //traduzir textos
                            openText="Abrir"
                            closeText="Fechar"
                            noOptionsText="Sem opções"
                            loadingText="Carregando..."


                            //estilização
                            disablePortal// menu de opções sempre ficar abaixo de onde digita
                            loading={isLoadingListaCliente}
                            popupIcon={isLoadingListaCliente ? <CircularProgress size={20} /> : undefined}//trocar o icone enquanto carrega os dados
                            sx={{ minWidth: 220, mb: 3 }}

                            //dados
                            options={opcoes}
                            onChange={(_, newValue) => {
                                if (newValue?.id) {
                                    setCnpjPerfil(newValue.id);
                                    filtraPerfisDisponiveis(newValue.id);
                                } else {
                                    setCnpjPerfil("");
                                    filtraPerfisDisponiveis("");
                                }

                            }}
                            /* value={clientesSelecionados.filter(cliente=>cnpjPerfil===cliente.cnpj)[0]} */
                            renderInput={(params) => <TextField {...params} label="Filtrar perfis por cliente" placeholder="Digite o nome..." />}
                        />
                    </Grid>
                )}

                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid item>{customListPerfis('Perfis disponíveis', perfisDisponiveis)}</Grid>
                    <Grid item>
                        <Grid container direction="column" alignItems="center">
                            <Button
                                sx={{
                                    my: 0.5,
                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                    '&.Mui-disabled': {
                                        color: 'theme.palette.action.disabled',
                                    },
                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                }}
                                variant="outlined"
                                size="small"
                                onClick={handlePerfisCheckedRight}
                                disabled={perfisDisponiveisChecked.length === 0}
                            >
                                &gt;
                            </Button>
                            <Button
                                sx={{
                                    my: 0.5,
                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                    '&.Mui-disabled': {
                                        color: 'theme.palette.action.disabled',
                                    },
                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                }}
                                variant="outlined"
                                size="small"
                                onClick={handlePerfisCheckedLeft}
                                disabled={perfisSelecionadosChecked.length === 0}
                            >
                                &lt;
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item>{customListPerfis(TITULO_PERFIS_SELECIONADOS, perfisSelecionados)}</Grid>
                </Grid>
            </Box>);

        }

    }

    //-------------------------------------------------------------------------------  Parte do transfer list -------------------------------------------------------------------------------
    function clienteNot(a: readonly ListaCliente[], b: readonly ListaCliente[]) {
        return a.filter((value) => b.indexOf(value) === -1);
    }

    function clienteIntersection(a: readonly ListaCliente[], b: readonly ListaCliente[]) {
        return a.filter((value) => b.indexOf(value) !== -1);
    }

    function clienteUnion(a: readonly ListaCliente[], b: readonly ListaCliente[]) {
        return [...a, ...clienteNot(b, a)];
    }

    const [clientes, setClientes] = useState<ICliente[]>([]);

    const [isLoadingListaCliente, setIsLoadingListaCliente] = useState(false);

    var objetoClientes: IUsuario_Cliente[] = [];

    const dataFetchedClientes_UsuarioRef = useRef(false);

    const [validadeSenhaFlag, setValidadeSenhaFlag] = useState(false);
    const [validadeSenha, setValidadeSenha] = useState('');

    const [vincularAD, setVincularAD] = useState(false);

    const [checkedClientes, setCheckedClientes] = useState<readonly ListaCliente[]>([]);
    const [clientesDisponiveis, setClientesDisponiveis] = useState<ListaCliente[]>([]);
    const [clientesSelecionados, setClientesSelecionados] = useState<ListaCliente[]>([]);

    const clientesDisponiveisChecked = clienteIntersection(checkedClientes, clientesDisponiveis);
    const clientesSelecionadosChecked = clienteIntersection(checkedClientes, clientesSelecionados);

    const handleToggleClientes = (value: ListaCliente) => () => {
        const currentIndex = checkedClientes.indexOf(value);
        const newChecked = [...checkedClientes];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setCheckedClientes(newChecked);
    };

    const listOfClientesChecked = (items: readonly ListaCliente[]) =>
        clienteIntersection(checkedClientes, items).length;

    const handleToggleAllClientes = (items: readonly ListaCliente[]) => () => {
        if (listOfClientesChecked(items) === items.length) {
            setCheckedClientes(clienteNot(checkedClientes, items));
        } else {
            setCheckedClientes(clienteUnion(checkedClientes, items));
        }
    };

    const handleClientesCheckedRight = () => {
        setClientesSelecionados(clientesSelecionados.concat(clientesDisponiveisChecked));
        setClientesDisponiveis(clienteNot(clientesDisponiveis, clientesDisponiveisChecked));
        setCheckedClientes(clienteNot(checkedClientes, clientesDisponiveisChecked));
    };

    const handleClientesCheckedLeft = () => {
        setClientesDisponiveis(clientesDisponiveis.concat(clientesSelecionadosChecked));
        setClientesSelecionados(clienteNot(clientesSelecionados, clientesSelecionadosChecked));
        setCheckedClientes(clienteNot(checkedClientes, clientesSelecionadosChecked));
    };

    const customListClientes = (title: React.ReactNode, items: readonly ListaCliente[]) => (
        <Card sx={{ border: 1 }}>
            <CardHeader
                sx={{ px: 2, py: 1 }}
                avatar={
                    <Checkbox
                        onClick={handleToggleAllClientes(items)}
                        checked={listOfClientesChecked(items) === items.length && items.length !== 0}
                        indeterminate={
                            listOfClientesChecked(items) !== items.length && listOfClientesChecked(items) !== 0
                        }
                        disabled={items.length === 0}
                    />
                }
                title={title}
                subheader={`${listOfClientesChecked(items)}/${items.length} selecionados`}
            />
            <Divider />
            <List
                sx={{
                    width: 220,
                    height: 230,
                    bgcolor: 'background.paper',
                    overflow: 'auto',
                }}
                dense
                component="div"
                role="list"
            >
                {isLoadingListaCliente ? (
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <CircularProgress /> </Box>
                ) : (
                    <>{items.map((value: ListaCliente) => {
                        const labelId = `transfer-list-all-item-${value}-label`;

                        return (
                            <ListItem
                                key={value.cnpj}
                                role="listitem"
                                onClick={handleToggleClientes(value)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checkedClientes.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.nome} />
                            </ListItem>
                        );
                    })}</>
                )}


                <ListItem />
            </List>
        </Card>
    );

    //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    function perfilNot(a: readonly ListaPerfil[], b: readonly ListaPerfil[]) {
        return a.filter((value) => b.indexOf(value) === -1);
    }

    function perfilIntersection(a: readonly ListaPerfil[], b: readonly ListaPerfil[]) {
        return a.filter((value) => b.indexOf(value) !== -1);
    }

    function perfilUnion(a: readonly ListaPerfil[], b: readonly ListaPerfil[]) {
        return [...a, ...perfilNot(b, a)];
    }

    function filtraPerfisDisponiveis(cnpjPerfilFiltrado: string) {
        var aux: ListaPerfil[] = [];
        var auxPerfis: IPerfil[] = perfis;
        perfis.map(perfil => {
            perfisSelecionados.map((selecionado, index) => {

                if (perfil.idPerfil === selecionado.idPerfil) {// se o usuario tem esse perfil
                    var id = selecionado.idPerfil;
                    var row = perfis.filter(perfil => perfil.idPerfil === id)[0];
                    var index = perfis.indexOf(row);

                    auxPerfis.splice(index, 1);
                }

            });
        });

        auxPerfis.map(perfil => {
            if (cnpjPerfilFiltrado !== "") {
                if (cnpjPerfilFiltrado === perfil.cnpj) {
                    aux.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj });
                }
            } else {
                aux.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj });
            }
        });

        setPerfisDisponiveis(aux);
    }

    const [perfis, setPerfis] = useState<IPerfil[]>([]);

    const [isLoadingListaPerfil, setIsLoadingListaPerfil] = useState(false);

    var objetoIdPerfis: Array<{ idUsuario: number, idPerfil: number }> = [];

    useEffect(() => {

        setPerfisDisponiveis([]);
        setPerfisSelecionados([]);

        if (visao === "master" && clientesSelecionados.length > 0 || (cnpj !== null && cnpj !== undefined && cnpj !== "")) {

            var arrayCnpjs: string[] = [];

            if (gestor || funcionarioCliente) {

                //@ts-expect-error
                arrayCnpjs = [cnpj];

            } else if (!master && clientesSelecionados.length > 0) {

                clientesSelecionados.map(cliente => {
                    arrayCnpjs.push(cliente.cnpj);
                });

            }

            if (!master && clientesSelecionados.length > 0 || (gestor || funcionarioCliente && (cnpj !== null && cnpj !== undefined && cnpj !== ""))) {

                setIsLoadingListaPerfil(true);
                if (idUsuario !== "novo") {
                    carregaPerfis(arrayCnpjs)
                }
                else {
                    Usuario_Perfil_Service.getAllByCnpjs(arrayCnpjs).then((result) => {

                        setIsLoadingListaPerfil(false);

                        if (result instanceof Error) {//verificar se deu erro

                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        } else {

                            setPerfis(result);

                            let auxPerfis: ListaPerfil[] = [];

                            result.map(perfil => auxPerfis.push({ idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }));
                            setPerfisDisponiveis(auxPerfis);
                        }
                    });
                }
            }
        }

        if (visao === "clienteGestor") {

            if (cnpj !== null && cnpj !== undefined && cnpj !== "") {
                setIsLoadingListaPerfil(true);

                Usuario_Perfil_Service.getAllByCnpjs([cnpj]).then((result) => {
                    setIsLoadingListaPerfil(false);

                    if (result instanceof Error) {//verificar se deu erro
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    }
                    else {

                        setPerfis(result);

                        if (idUsuario === "novo") {
                            result.map(perfil => setPerfisDisponiveis((prevNames) => [...prevNames, { idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }]));
                        }

                    }
                });
            }

        }

    }, [clientesSelecionados, cnpj, master, gestor, funcionarioCliente]);

    const [checkedPerfis, setCheckedPerfis] = useState<readonly ListaPerfil[]>([]);
    const [perfisDisponiveis, setPerfisDisponiveis] = useState<ListaPerfil[]>([]);
    const [perfisSelecionados, setPerfisSelecionados] = useState<ListaPerfil[]>([]);

    const perfisDisponiveisChecked = perfilIntersection(checkedPerfis, perfisDisponiveis);
    const perfisSelecionadosChecked = perfilIntersection(checkedPerfis, perfisSelecionados);

    const handleTogglePerfis = (value: ListaPerfil) => () => {
        const currentIndex = checkedPerfis.indexOf(value);
        const newChecked = [...checkedPerfis];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setCheckedPerfis(newChecked);
    };

    const listOfPerfisChecked = (items: readonly ListaPerfil[]) =>
        perfilIntersection(checkedPerfis, items).length;

    const handleToggleAllPerfis = (items: readonly ListaPerfil[]) => () => {
        if (listOfPerfisChecked(items) === items.length) {
            setCheckedPerfis(perfilNot(checkedPerfis, items));
        } else {
            setCheckedPerfis(perfilUnion(checkedPerfis, items));
        }
    };

    const handlePerfisCheckedRight = () => {
        setPerfisSelecionados(perfisSelecionados.concat(perfisDisponiveisChecked));
        setPerfisDisponiveis(perfilNot(perfisDisponiveis, perfisDisponiveisChecked));
        setCheckedPerfis(perfilNot(checkedPerfis, perfisDisponiveisChecked));
    };

    const handlePerfisCheckedLeft = () => {
        setPerfisDisponiveis(perfisDisponiveis.concat(perfisSelecionadosChecked));
        setPerfisSelecionados(perfilNot(perfisSelecionados, perfisSelecionadosChecked));
        setCheckedPerfis(perfilNot(checkedPerfis, perfisSelecionadosChecked));
    };

    /* useEffect(() => {
        if (idUsuario !== "novo" && clientesSelecionados.length > 0) {
            perfis.map(perfil => setPerfisDisponiveis((prevNames) => [...prevNames, { idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }]));
            perfis.map(perfil => {
                perfis_usuario.map((perfil_usuario, index) => {
    
                    if (perfil.idPerfil == perfil_usuario.idPerfil) {// se o usuario tem esse perfil
                        setPerfisSelecionados((prevNames) => [...prevNames, { idPerfil: perfil.idPerfil, nomePerfil: perfil.nomePerfil, cnpj: perfil.cnpj }]);// adiciona na lista de selecionados
                        setPerfisDisponiveis((current) => current.filter((disponiveis) => disponiveis.idPerfil !== perfil.idPerfil));// remove da lista de disponiveis
                    }
    
                });
            });
        }
        if (clientesSelecionados.length === 0 && visao !== "clienteGestor") {
            setPerfisDisponiveis([]);
            setPerfisSelecionados([]);
        }
    }, [clientesSelecionados, perfis]); */

    const TITULO_PERFIS_SELECIONADOS = 'Perfis selecionados';
    const customListPerfis = (title: React.ReactNode, items: readonly ListaPerfil[]) => (
        <Card sx={{ border: 1 }}>
            <CardHeader
                sx={{ px: 2, py: 1 }}
                avatar={
                    <Checkbox
                        onClick={handleToggleAllPerfis(items)}
                        checked={listOfPerfisChecked(items) === items.length && items.length !== 0}
                        indeterminate={
                            listOfPerfisChecked(items) !== items.length && listOfPerfisChecked(items) !== 0
                        }
                        disabled={items.length === 0}
                    />
                }
                title={title}
                subheader={`${listOfPerfisChecked(items)}/${items.length} selecionados`}
            />
            <Divider />
            <List
                sx={{
                    width: 220,
                    height: 230,
                    bgcolor: 'background.paper',
                    overflow: 'auto',
                }}
                dense
                component="div"
                role="list"
            >
                {isLoadingListaPerfil ? (
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <CircularProgress /> </Box>
                ) : (
                    <>{items.map((value: ListaPerfil) => {
                        const labelId = `transfer-list-all-item-${value}-label`;
                        var display = "";
                        if (value.cnpj !== cnpjPerfil && cnpjPerfil !== "" && title !== TITULO_PERFIS_SELECIONADOS) display = "none";

                        return (
                            <ListItem
                                key={value.idPerfil}
                                role="listitem"
                                onClick={handleTogglePerfis(value)}
                                sx={{ display: display }}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checkedPerfis.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.nomePerfil} />
                            </ListItem>
                        );
                    })}</>
                )}

                <ListItem />
            </List>
        </Card>
    );

    //-------------------------------------------------------------------------------  Fim da parte do transfer list -------------------------------------------------------------------------------

    const handleSave = (dados: IFormData) => {
        if (!master && !gestor && !funcionarioCliente && clientesSelecionados.length === 0 && visao === "master") {// se for um funcionario zdoc, visão master
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione ao menos um cliente para o funcionário" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else if (!master && !gestor && perfisSelecionados.length === 0 && visao === "master") {// se for um funcionario zdoc, visão master
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione ao menos um perfil para o funcionário" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else if ((gestor || funcionarioCliente) && cnpj === undefined || cnpj === null || cnpj == '' && visao === "master") {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um cliente" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else {
            //retirar máscaras
            let unmaskedCpf = maskedCpf.replaceAll('.', '');
            unmaskedCpf = unmaskedCpf.replaceAll('-', '');
            unmaskedCpf = unmaskedCpf.replaceAll('_', '');
            dados.cpf = unmaskedCpf;

            let unmaskedCelular = maskedCelular.replace('(', '');
            unmaskedCelular = unmaskedCelular.replace(')', '');
            unmaskedCelular = unmaskedCelular.replaceAll(' ', '');
            unmaskedCelular = unmaskedCelular.replace('-', '');
            unmaskedCelular = unmaskedCelular.replaceAll('_', '');
            dados.celular = unmaskedCelular;

            dados.uf = uf;

            dados.master = master;
            dados.gestor = gestor;

            if (visao === "master") {
                dados.funcionarioZ = !funcionarioCliente;
            }

            formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
                setIsLoading(true);

                if (email === dados.email) { // se não foi alterado, retira do objeto da request
                    // @ts-expect-error 
                    delete dados.email;
                }

                //se não foi alterado, não adiciona no objeto da request
                if (cpf === maskedCpf) {
                    // @ts-expect-error 
                    delete dados.cpf;
                }
                if (celular === maskedCelular) {
                    // @ts-expect-error 
                    delete dados.celular;
                }

                if (validadeSenhaFlag) {
                    dados.expiracaoSenha = validadeSenha;
                }

                if (idUsuario === 'novo') {

                    UsuarioService.create(dados, vincularAD).then((result) => {
                        setIsLoading(false);
                        if (result instanceof Error) {
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        } else {
                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Usuário cadastrado" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            if ((!master && (gestor || funcionarioCliente)) || visao === "clienteGestor") {
                                if (!!cnpj) {
                                    objetoClientes.push({
                                        'idUsuario': result,
                                        'cnpj': cnpj
                                    });
                                }
                            } else if (!master && !gestor && !funcionarioCliente) {// se for funcionário zdoc
                                clientesSelecionados.forEach(function (cliente) {
                                    objetoClientes.push({
                                        'idUsuario': result,
                                        'cnpj': cliente.cnpj
                                    });
                                });
                            }

                            if (!master) {
                                //@ts-expect-error
                                Usuario_Cliente_Service.create(objetoClientes).then((result) => {
                                    setIsLoading(false);
                                    if (result instanceof Error) {
                                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);
                                    }
                                    else {
                                        if (isSaveAndReturn()) {
                                            navigate('/usuario')
                                        } else {
                                            limparCampos();
                                        }
                                    }
                                });
                            }
                            else {
                                if (isSaveAndReturn()) {
                                    navigate('/usuario')
                                } else {
                                    limparCampos();
                                }
                            }

                            if (!master && !gestor) {

                                perfisSelecionados.forEach(function (perfil) {
                                    objetoIdPerfis.push(
                                        {
                                            'idUsuario': result,
                                            'idPerfil': perfil.idPerfil
                                        },
                                    );
                                });

                                Usuario_Perfil_Service.create(result, objetoIdPerfis).then((result) => {
                                    if (result instanceof Error) {
                                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);
                                    } else {

                                        if (isSaveAndReturn()) {
                                            navigate('/usuario')
                                        } else {
                                            limparCampos();
                                        }

                                    }
                                });

                            }
                        }
                    });


                } else {

                    UsuarioService.updateById(Number(idUsuario), { idUsuario: Number(idUsuario), ...dados }, vincularAD).then((result) => {

                        setIsLoading(false);

                        if (result instanceof Error) {

                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        } else {

                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Usuário atualizado" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            setNome(dados.nome);
                            setEmail(dados.email);
                            setCpf(dados.cpf);
                            setCelular(dados.celular);

                            if ((!master && (gestor || funcionarioCliente)) || visao === "clienteGestor") {

                                if (!!cnpj) {

                                    objetoClientes.push({
                                        'idUsuario': Number(idUsuario),
                                        'cnpj': cnpj
                                    });

                                }

                            } else if (!master && !gestor && !funcionarioCliente) {// se for funcionário zdoc

                                clientesSelecionados.forEach(function (cliente) {

                                    objetoClientes.push({
                                        'idUsuario': Number(idUsuario),
                                        'cnpj': cliente.cnpj
                                    });

                                });

                            }

                            if (!master) {

                                //@ts-expect-error
                                Usuario_Cliente_Service.create(objetoClientes).then((result) => {

                                    setIsLoading(false);

                                    if (result instanceof Error) {

                                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);

                                    }

                                });
                            }

                            if (!master && !gestor) {

                                perfisSelecionados.forEach(function (perfil) {
                                    objetoIdPerfis.push(
                                        {
                                            'idUsuario': Number(idUsuario),
                                            'idPerfil': perfil.idPerfil
                                        },
                                    );
                                });


                                if (Object.keys(objetoIdPerfis).length === 0) {// se não tiver nada na lista

                                    Usuario_Perfil_Service.deleteByIdUsuario(Number(idUsuario)).then((result) => {

                                        setIsLoading(false);

                                        if (result instanceof Error) {

                                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                            setTimeout(() => {
                                                setAlertSnackbar(undefined);
                                            }, duracaoAlert);

                                        } else {

                                            if (isSaveAndReturn()) {
                                                navigate('/usuario')
                                            }

                                        }
                                    });

                                } else {

                                    Usuario_Perfil_Service.create(Number(idUsuario), objetoIdPerfis).then((result) => {

                                        setIsLoading(false);

                                        if (result instanceof Error) {

                                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                            setTimeout(() => {
                                                setAlertSnackbar(undefined);
                                            }, duracaoAlert);

                                        } else {

                                            if (isSaveAndReturn()) {
                                                navigate('/usuario')
                                            }

                                        }
                                    });

                                }
                            }
                        }
                    });
                }
            }).catch((errors: yup.ValidationError) => {

                const validationErrors: { [key: string]: string } = {};

                errors.inner.forEach(error => {
                    if (!error.path) return;

                    validationErrors[error.path] = error.message;
                    if (error.path === "uf") setErrorUf(true);
                    if (error.path === "cpf") setErrorCpf(true);
                    if (error.path === "celular") setErrorCelular(true);
                });

                formRef.current?.setErrors(validationErrors);

            });
        }
    }
    const handleDelete = () => {

        UsuarioService.toggleEnabledById(Number(idUsuario)).then(result => {

            if (result instanceof Error) {//verificar se deu erro

                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

            } else {

                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Usuário desativado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

                navigate('/usuario');

            }
        });
    }

    const [abrir, setAbrir] = useState(false);
    const handleCancel = () => {
        setAbrir(false);
    };

    return (

        <LayoutBaseDePagina
            titulo={idUsuario == 'novo' ? 'Novo usuário' : nome}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={idUsuario !== 'novo'}
                    mostrarBotaoNovo={idUsuario !== 'novo'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/usuario/detalhe/novo')}
                    aoClicarEmVoltar={() => navigate('/usuario')}
                />
            }
        >
            {alertSnackbar !== undefined && (
                <>
                    {alertSnackbar.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar o usuário?"}
                texto={"Ao confirmar, o usuário irá perder acesso completo ao sistema e será necessário reativá-lo na listagem de usuários desativados, para que ele possa usar novamente o sistema."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />

            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2} >

                            <Grid item xs={12} sm={12} md={4}>
                                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nome" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={2}>
                                <CampoTextoMascarado
                                    fullWidth
                                    mask="999.999.999-99"
                                    label="CPF"
                                    name="cpf"
                                    disabled={isLoading}
                                    error={errorCpf}
                                    helperText={errorCpf && "Digite um CPF válido"}
                                    value={maskedCpf}
                                    onChange={(valorMascarado) => handleChangeCpf(valorMascarado)}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item direction="row" spacing={2}>
                            <Grid item xs={12} sm={12} md={4}>
                                <VTextField fullWidth label="Email" placeholder="Digite o email..." name="email" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={2}>
                                <CampoTextoMascarado
                                    fullWidth
                                    mask="(99) \9 9999-9999"
                                    label="Celular"
                                    name="celular"
                                    disabled={isLoading}
                                    error={errorCelular}
                                    helperText={errorCelular && "Digite todos os números do celular"}
                                    value={maskedCelular}
                                    onChange={(valorMascarado) => handleChangeCelular(valorMascarado)}
                                />
                            </Grid>

                            <Grid container item direction="row" spacing={2}>

                                <Grid item xs={6} sm={6} md={3} lg={3} xl={2}>

                                    <FormControl fullWidth>
                                        <InputLabel id="select-component-label"> UF </InputLabel>
                                        <Select
                                            labelId="select-component-label"
                                            id="select"
                                            label="UF"
                                            disabled={isLoading}
                                            value={uf}
                                            onChange={handleChangeUf}

                                            error={errorUf}//  se tiver algum erro
                                        >
                                            <MenuItem value={"AC"}>AC</MenuItem>
                                            <MenuItem value={"AL"}>AL</MenuItem>
                                            <MenuItem value={"AM"}>AM</MenuItem>
                                            <MenuItem value={"AP"}>AP</MenuItem>
                                            <MenuItem value={"BA"}>BA</MenuItem>
                                            <MenuItem value={"CE"}>CE</MenuItem>
                                            <MenuItem value={"DF"}>DF</MenuItem>
                                            <MenuItem value={"ES"}>ES</MenuItem>
                                            <MenuItem value={"GO"}>GO</MenuItem>
                                            <MenuItem value={"MA"}>MA</MenuItem>
                                            <MenuItem value={"MG"}>MG</MenuItem>
                                            <MenuItem value={"MS"}>MS</MenuItem>
                                            <MenuItem value={"MT"}>MT</MenuItem>
                                            <MenuItem value={"PA"}>PA</MenuItem>
                                            <MenuItem value={"PB"}>PB</MenuItem>
                                            <MenuItem value={"PE"}>PE</MenuItem>
                                            <MenuItem value={"PI"}>PI</MenuItem>
                                            <MenuItem value={"PR"}>PR</MenuItem>
                                            <MenuItem value={"RJ"}>RJ</MenuItem>
                                            <MenuItem value={"RN"}>RN</MenuItem>
                                            <MenuItem value={"RO"}>RO</MenuItem>
                                            <MenuItem value={"RR"}>RR</MenuItem>
                                            <MenuItem value={"RS"}>RS</MenuItem>
                                            <MenuItem value={"SC"}>SC</MenuItem>
                                            <MenuItem value={"SE"}>SE</MenuItem>
                                            <MenuItem value={"SP"}>SP</MenuItem>
                                            <MenuItem value={"TO"}>TO</MenuItem>
                                        </Select>
                                        {errorUf && (
                                            <FormHelperText error>Selecione um estado</FormHelperText>
                                        )}
                                    </FormControl>

                                </Grid>

                                <Grid item>
                                    <Box
                                        display="flex"
                                        gap={1}
                                        alignItems="center"
                                    >
                                        {visao === "master" && !gestor && !funcionarioCliente && (
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Switch
                                                        checked={master}
                                                        onChange={e => setMaster(e.target.checked)}
                                                        disabled={isLoading}
                                                    />
                                                }
                                                    label="Master"
                                                />
                                            </FormGroup>
                                        )}
                                        {!master && !funcionarioCliente && (
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Switch
                                                        checked={gestor}
                                                        onChange={e => setGestor(e.target.checked)}
                                                        disabled={isLoading}
                                                    />
                                                }
                                                    label="Gestor"
                                                />
                                            </FormGroup>
                                        )}
                                        {visao === "master" && !gestor && !master && (
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Switch
                                                        checked={funcionarioCliente}
                                                        onChange={e => {
                                                            setFuncionarioCliente(e.target.checked);
                                                            setCnpjPerfil("");
                                                        }}
                                                        disabled={isLoading}
                                                    />
                                                }
                                                    label="Colaborador do cliente"
                                                />
                                            </FormGroup>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>


                            <Grid item xs={12} sm={12} md={4} lg={4} display={"flex"} flexDirection={"column"}>
                                <FormControl>
                                    <FormControlLabel control={
                                        <Checkbox
                                            checked={validadeSenhaFlag}
                                            onChange={_ => { setValidadeSenhaFlag(!validadeSenhaFlag); setValidadeSenha('') }}
                                            disabled={isLoading}
                                        />}
                                        label="Controlar validade de senha" />
                                </FormControl>

                                <FormControl>
                                    <FormControlLabel control={
                                        <Checkbox
                                            checked={vincularAD}
                                            onChange={_ => { setVincularAD(!vincularAD); }}
                                            disabled={isLoading}
                                        />}
                                        label="Vincular usuário ao Active Directory" />
                                </FormControl>


                                {validadeSenhaFlag &&

                                    <Grid mt={2}>
                                        <DatePicker
                                            label={"Data de expiração"}
                                            disabled={isLoading}
                                            slotProps={{ textField: { fullWidth: true } }}
                                            //@ts-expect-error
                                            value={validadeSenha === "" || validadeSenha === undefined || validadeSenha === null ? null : dayjs(validadeSenha, 'YYYY-MM-DD')}
                                            onChange={(newValue: Date | null) => {

                                                setValidadeSenha(() => {
                                                    if (newValue !== null) {
                                                        //@ts-expect-error
                                                        return newValue.format('YYYY-MM-DD');
                                                    }
                                                });

                                            }}
                                        />
                                    </Grid>

                                }
                            </Grid>

                        </Grid>
                    </Grid>

                    <Box sx={{ display: { lg: 'block', xl: 'inline-flex' } }} gap={10} justifyContent={"center"} width={"100%"}>
                        {selecaoCliente()}

                        {selecaoPerfil()}
                    </Box>

                </VForm>

            </Box>

        </LayoutBaseDePagina >
    )
}